import React, { useState } from 'react';
import styled from 'styled-components';
import Info2 from '../../../../icons/Info2';
import Xcircle from '../../../../icons/Xcircle';
import { Link } from '../../navigation/Link';
import { Button } from '../../inputs/Button';

interface Props {}

const DocumentationSidePanel: React.FC<Props> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  // TODO Remove
  if (process.env.REACT_APP_ENV == 'production') {
    return <></>;
  }

  return (
    <StyledSidePanel className="shadow-lg" isOpen={isOpen}>
      <StyledButton className="flex justify-center items-center" onClick={() => setIsOpen(!isOpen)}>
        <div>{isOpen ? <Xcircle /> : <Info2 />}</div>
      </StyledButton>
      <StyledSidePanelContent className="flex flex-col justify-between h-full">
        <div>{children}</div>
        <StyledViewButton>
          <Link href="https://www.google.com" target="_blank">
            <Button variant="outlined">View full documentation</Button>
          </Link>
        </StyledViewButton>
      </StyledSidePanelContent>
    </StyledSidePanel>
  );
};

const StyledSidePanel = styled.div<{ isOpen: boolean }>`
  position: absolute;
  bottom: 0;
  right: 0;
  height: calc(100% - 4rem);
  width: ${(props) => (props.isOpen ? '22.5rem' : '0rem')};
  background-color: #ffffff;
  overflow-x: hidden;
  //transition: 0.3s;
  z-index: 11;
`;

const StyledButton = styled.div`
  position: fixed;
  margin-top: 2rem;
  margin-left: -2.5rem;

  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  background-color: #24b400;
  color: #fff;
  width: 2.5rem;
  height: 2.5rem;

  cursor: pointer;

  svg {
    margin-top: initial;
    margin-left: 2px;
    position: initial;
    top: initial;
    left: initial;
    width: 1.6rem;
    height: 1.6rem;
  }
`;

const StyledSidePanelContent = styled.div`
  padding: 1.875rem;

  h3 {
    font-weight: 500;
    font-size: 1.5rem;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  p {
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }
`;

const StyledViewButton = styled.div`
  width: 100%;
  button {
    border-color: #24b400;
    color: #24b400 !important;
    width: 100%;
  }
`;

export default DocumentationSidePanel;
